<template>
  <BaseFormLayout
    :title="`Add ${supportModule.ticket}`"
    :nonFieldErrors="
      formErrors && formErrors.non_field_errors
        ? formErrors.non_field_errors
        : []
    "
  >
    <template #actions>
      <SecondaryButton
        id="supportReset"
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="supportSubmit"
        v-if="
          userDetails.role == 'support_user' ||
          userDetails.role == 'system_admin'
        "
        @click="submitSupportUserForm()"
        :disabled="!isValid"
        name="Submit"
        btnClass="text-uppercase rounded-lg"
      >
      </PrimaryButton>
      <PrimaryButton
        id="supportSubmit"
        v-else
        @click="submitForm()"
        :disabled="!isValid"
        name="Submit"
        btnClass="text-uppercase rounded-lg"
      >
        Submit
      </PrimaryButton>
    </template>
    <template #content>
      <v-row >
        <v-col cols="12" lg="8" class="pr-2">
          <v-form
            v-model="isValid"
            ref="ticketForm"
            :key="formCount"
            @submit.prevent="submitForm"
          >
            <v-card class="pa-5 rounded-lg" elevation="0">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-row class="ma-0">
                    <v-col cols="12">
                      <span class="text-subtitle-1 font-weight-bold">
                        Basic Details
                      </span>
                    </v-col>
                    <v-col cols="12" md="4" lg="6">
                      <InputField
                        id="title"
                        v-model="ticketDetails.title"
                        label="Title"
                        name="title"
                        :required="true"
                        :error-messages="formErrors.title"
                        @input="delete formErrors.title"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="6"
                      v-if="
                        userDetails.role == 'support_user' ||
                        userDetails.role == 'system_admin'
                      "
                    >
                      <SelectField
                        id="company"
                        label="Company *"
                        :itemsList="companySelectList"
                        item-text="name"
                        item-value="id"
                        name="company"
                        @change="getAccountAdminList"
                        v-model="ticketDetails.company"
                        :rules="[(val) => !!val || 'Company is required']"
                        :error-messages="formErrors.company"
                        @input="delete formErrors.company"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="6"
                      v-if="
                        userDetails.role == 'support_user' ||
                        userDetails.role == 'system_admin'
                      "
                    >
                      <SelectField
                        id="user"
                        label="user *"
                        :itemsList="accountAdminList"
                        name="user"
                        item-text="username"
                        item-value="id"
                        v-model="ticketDetails.user"
                        :rules="[(val) => !!val || 'user is required']"
                        :error-messages="formErrors.user"
                        @input="delete formErrors.user"
                      />
                    </v-col>
                    <!-- <v-col cols="12" md="4" lg="4">
                      <InputField
                        v-model="ticketDetails.customer_name"
                        label="Customer Name"
                        :required="true"
                        :error-messages="formErrors.customer_name"
                        @input="delete formErrors.customer_name"
                      />
                    </v-col>
                    <v-col cols="12" md="4" lg="4">
                      <InputField
                        v-model="ticketDetails.customer_email"
                        label="Customer email"
                        :required="true"
                        :error-messages="formErrors.customer_email"
                        @input="delete formErrors.customer_email"
                      />
                    </v-col> -->
                    <v-col cols="12" md="4" lg="12">
                      <TextAreaField
                        id="description"
                        v-model="ticketDetails.description"
                        name="description"
                        label="description"
                        auto-grow
                        :required="true"
                        :error-messages="formErrors.description"
                        @input="delete formErrors.description"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="pa-5 rounded-lg mt-4" elevation="0">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-row class="ma-0">
                    <v-col cols="12">
                      <span class="text-subtitle-1 font-weight-bold">
                        Other Details
                      </span>
                    </v-col>
                    <v-col cols="12" md="4" lg="4">
                      <SelectField
                        id="module"
                        v-model="ticketDetails.module"
                        :itemsList="ticketOption.module"
                        name="module"
                        itemText="display_value"
                        itemValue="value"
                        label="select module *"
                        :rules="[(v) => !!v || 'Module is required']"
                        :error-messages="formErrors.module"
                        @input="delete formErrors.module"
                      />
                    </v-col>
                    <!-- <v-col cols="12" md="4" lg="4">
                      <SelectField
                        v-model="ticketDetails.category"
                        :itemsList="ticketOption.category"
                        itemText="display_value"
                        itemValue="value"
                        label="select Category"
                        :required="true"
                        :rules="[(v) => !!v || 'Category is required']"
                        :error-messages="formErrors.category"
                        @input="delete formErrors.category"
                      />
                    </v-col> -->
                    <v-col cols="12" md="4" lg="4">
                      <SelectField
                        id="impact"
                        v-model="ticketDetails.impact"
                        :itemsList="ticketOption.impact"
                        name="impact"
                        itemText="display_value"
                        itemValue="value"
                        label="Select Business Impact *"
                        :rules="[(v) => !!v || 'Business Impact is required']"
                        :error-messages="formErrors.impact"
                        @input="delete formErrors.impact"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-col>
        <v-col cols="12" lg="4" class="pl-2">
          <v-card class="pa-4 rounded-lg" elevation="0">
            <v-row no-gutters>
              <v-col cols="12">
                <v-row class="ma-0">
                  <v-col cols="12">
                    <span class="text-subtitle-1 font-weight-bold">
                      New Attachments
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <v-card elevation="0" class="rounded-lg" outlined>
                      <v-row no-gutters class="pa-4">
                        <v-col cols="8">
                          <h6 class="font-weight-light">File Name</h6>
                        </v-col>
                        <v-col cols="2">
                          <h6 class="font-weight-light">Size</h6>
                        </v-col>
                        <v-col cols="2">
                          <h6 class="font-weight-light text-right pr-4">
                            Action
                          </h6>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <div
                        style="height: calc(100vh - 660px)"
                        class="overflow-y-auto"
                      >
                        <v-row
                          no-gutters
                          class="px-4 py-2"
                          v-for="(attachment, index) in documentList"
                          :key="index"
                        >
                          <v-col cols="8">
                            <a
                              target="_blank"
                              class="text-caption"
                              :href="generateUrl(attachment)"
                            >
                              {{ attachment.name }}
                            </a>
                          </v-col>
                          <v-col cols="2">
                            <h6 class="font-weight-light">
                              {{ getSize(attachment.size) }}
                            </h6>
                          </v-col>
                          <v-col cols="2">
                            <h6 class="text-right">
                              <a
                                :href="generateUrl(attachment)"
                                target="_blank"
                                style="text-decoration: none"
                              >
                                <v-icon
                                  small
                                  color="secondary darken-2"
                                  class="mr-4"
                                >
                                  mdi-eye
                                </v-icon>
                              </a>
                              <v-icon
                                small
                                color="error"
                                class="mr-1"
                                @click="removeAttachment(index)"
                              >
                                mdi-delete
                              </v-icon>
                            </h6>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="pa-4 rounded-lg" elevation="0" v-if="editMode">
            <v-row no-gutters>
              <v-col cols="12">
                <v-row class="ma-0">
                  <v-col cols="12">
                    <span class="text-subtitle-1 font-weight-bold">
                      Uploaded Attachments
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <v-card elevation="0" class="rounded-lg" outlined>
                      <v-row no-gutters class="pa-4">
                        <v-col cols="4">
                          <h6 class="font-weight-light">File Name</h6>
                        </v-col>
                        <v-col cols="4">
                          <h6 class="font-weight-light">Size</h6>
                        </v-col>
                        <v-col cols="4">
                          <h6 class="font-weight-light text-right pr-4">
                            Action
                          </h6>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <div style="min-height: 20vh" class="overflow-y-auto">
                        <v-row
                          no-gutters
                          class="px-4 py-2"
                          v-for="(attachment, index) in attachmentList"
                          :key="index"
                        >
                          <v-col cols="6">
                            <a class="text-caption" href="#">
                              {{ attachment.attachment_url }}
                            </a>
                          </v-col>
                          <v-col cols="4">
                            <h6 class="font-weight-light">
                              {{ getSize(attachment.size) }}
                            </h6>
                          </v-col>
                          <v-col cols="2">
                            <h6 class="text-right">
                              <a
                                :href="attachment.attachment_url"
                                target="_blank"
                                style="text-decoration: none"
                              >
                                <v-icon
                                  small
                                  color="secondary darken-2"
                                  class="mr-4"
                                >
                                  mdi-eye
                                </v-icon>
                              </a>
                              <v-icon small color="error" class="mr-1">
                                mdi-delete
                              </v-icon>
                            </h6>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" class="pt-1">
          <v-card class="pa-5 rounded-lg" elevation="0">
            <FileUpload
              @selectedFile="getSelectFiles"
              :multiple="true"
              :list="documentList"
              ref="fileUpload"
              height="calc(100vh - 710px)"
            />
          </v-card>
        </v-col>
      </v-row>
    </template>
  </BaseFormLayout>
</template>

<script>
import { bus } from "@/main.js";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import { generatedFormData, loadGoogleInstance } from "@/utils/functions";
import { supportModule } from "@/utils/moduleMapping";

export default {
  components: {
    BaseFormLayout,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
  },
  data() {
    return {
      supportModule,
      attachmentList: [],
      uploadFiles: null,
      fileInput: null,
      formCount: 0,
      isValid: true,
      ticketDetails: {},
      ticketID: null,
      formErrors: {},
      documentList: [],
      userDetails: this.$helper.getUserDetailsLocalStorage(),
      ticketOption: {
        module: [],
        category: [],
        impact: [],
      },
      companySelectList: [],
      accountAdminList: [],
    };
  },
  methods: {
    getSelectFiles(list) {
      this.documentList = list;
    },
    getAccountAdminList(id) {
      bus.$emit("showLoader", true);
      this.$api.accountAdmin
        .getAccountAdminList({
          company: id,
          limit: "all",
        })
        .then((res) => {
          this.accountAdminList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getCompanySelectList() {
      bus.$emit("showLoader", true);
      this.$api.company
        .getCompanySelectList({
          limit: "all",
        })
        .then((res) => {
          this.companySelectList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    resetForm() {
      this.ticketDetails = {};
      this.$refs.ticketForm.resetValidation();
      this.$refs.fileUpload.removeFile();
      this.documentList = [];
    },
    generateUrl(file) {
      return URL.createObjectURL(file);
    },
    getSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    removeAttachment(index) {
      this.documentList.splice(index, 1);
    },
    onFileChanged() {
      const selectedFile = this.uploadFiles;
      if (
        selectedFile &&
        selectedFile.type &&
        selectedFile.type.toLowerCase().indexOf("png") == -1 &&
        selectedFile.type.toLowerCase().indexOf("jpg") == -1 &&
        selectedFile.type.toLowerCase().indexOf("jpeg") == -1
      ) {
        setTimeout(() => {
          this.uploadFiles = null;
          this.$refs.fileUpload.blur();
        }, 10);
        alert("File type not supported \nSupported Types: PNG, JPG, JPEG");
      } else {
        this.documentList.push(selectedFile);
        this.uploadFiles = null;
        this.$refs.fileUpload.blur();
      }

      this.$forceUpdate();
    },
    //   getDriverObject(id) {
    //     bus.$emit("showLoader", true);
    //     this.$api.driver
    //       .getDriverObject(id)
    //       .then((res) => {
    //         this.ticketDetails = res.data;
    //         if (res && res.data && res.data.profile_image) {
    //           this.profileImage = res.data.profile_image;
    //           delete res.data.profile_image;
    //         }
    //         this.getVehicleList(this.ticketDetails.branch);
    //         this.getZoneList(this.ticketDetails.branch);
    //         bus.$emit("showLoader", false);
    //       })
    //       .catch((err) => {
    //         console.error(err);
    //         bus.$emit("showLoader", false);
    //       });
    //   },
    submitSupportUserForm() {
      let data = { ...this.ticketDetails };
      bus.$emit("showLoader", true);
      if (this.editMode) {
        this.$api.supportUserTicket
          .updateSupport({
            id: this.ticketDetails.id,
            data: data,
          })
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Ticket information updated!",
              color: "success",
            });
            this.resetForm();
            this.$router.back();
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            this.formErrors = err.data;
          });
      } else {
        this.$api.supportUserTicket
          .createTicket(data)
          .then((res) => {
            this.ticketID = res?.data?.id;

            if (this.documentList.length > 0) {
              this.documentList.forEach((document, index) => {
                let payload = {};
                payload.attachment = document;
                payload.ticket = this.ticketID;
                this.addTicketAttachment(payload);
                if (this.documentList.length == index + 1) {
                  bus.$emit("showToastMessage", {
                    message: "Uploaded Attachment Successfully!",
                    color: "success",
                  });
                  this.resetForm();
                  this.$router.back();
                }
              });
            } else {
              this.resetForm();
              this.$router.back();
            }
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Ticket Generated Successfully!",
              color: "success",
            });
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            this.formErrors = err.data;
          });
      }
    },
    submitForm() {
      let data = { ...this.ticketDetails };
      bus.$emit("showLoader", true);
      if (this.editMode) {
        this.$api.support
          .updateSupport({
            id: this.ticketDetails.id,
            data: data,
          })
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Ticket information updated!",
              color: "success",
            });
            this.resetForm();
            this.$router.back();
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            this.formErrors = err.data;
          });
      } else {
        this.$api.support
          .createTicket(data)
          .then((res) => {
            this.ticketID = res?.data?.id;

            if (this.documentList.length > 0) {
              let i;
              for (i = 0; i < this.documentList.length; i++) {
                let payload = {};
                payload.attachment = this.documentList[i];
                payload.ticket = this.ticketID;
                this.addTicketAttachment(payload);
                if (i == this.documentList.length - 1) {
                  bus.$emit("showToastMessage", {
                    message: "Uploaded Attachment Successfully!",
                    color: "success",
                  });
                }
              }
            }
            this.resetForm();
            this.$router.back();
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Ticket Generated Successfully!",
              color: "success",
            });
          })
          .catch((err) => {
            console.log(err);
            bus.$emit("showLoader", false);
            this.formErrors = err.data;
          });
      }
    },
    addTicketAttachment(payload) {
      this.$api.support
        .addTicketAttachment(generatedFormData(payload))
        .then(() => {
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          this.formErrors = err.data;
        });
    },
    getFieldConfigurationList() {
      bus.$emit("showLoader", true);
      this.$api.fieldConfiguration
        .getFieldConfigurationList({ limit: "all", search: "license type" })
        .then((res) => {
          this.licenseTypeList = res.data.map((field) => field.name);
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    setAutoCompletedRestriction() {
      if (this.ticketDetails.branch && this.branchList) {
        let branch = this.branchList.find(
          (v) => v.id == this.ticketDetails.branch
        );
        if (branch && branch.country_code) {
          this.addressField.setComponentRestrictions({
            country: [branch.country_code],
          });
        }
      }
      this.setRestLocation();
    },
    setRestLocation() {
      this.ticketDetails.address = null;
      this.ticketDetails.coordinates = {};
    },
    loadAutoComplete() {
      const interval = setInterval(async () => {
        if (this.$refs.addressField && window.google && window.google.maps) {
          clearInterval(interval);

          let addressField = document.getElementById("addressField");

          this.addressField = new window.google.maps.places.Autocomplete(
            addressField
          );

          if (this.userDetails?.preferred_branch?.country_code) {
            this.addressField.setComponentRestrictions({
              country: [this.userDetails.preferred_branch.country_code],
            });
          } else {
            this.addressField.setComponentRestrictions({
              country: ["AE"],
            });
          }

          addressField.setAttribute("placeholder", "");

          this.addressField.addListener("place_changed", () => {
            let place = this.addressField.getPlace();

            this.ticketDetails = {
              ...this.ticketDetails,
              coordinates: {
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng(),
              },
              address: place.formatted_address,
            };
          });
        } else {
          loadGoogleInstance();
        }
      }, 100);
    },
    getSupportOptions(params = {}) {
      params = {
        ...params,
        request_type: "form",
      };
      bus.$emit("showLoader", true);
      this.$api.support
        .getSupportOptions(params)
        .then((res) => {
          this.ticketOption = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    this.getSupportOptions();
    if (
      (this.userDetails && this.userDetails.role == "support_user") ||
      this.userDetails.role == "system_admin"
    ) {
      this.getCompanySelectList();
    }
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
.Map-Height {
  height: calc(100vh - 300px);
}
</style>
